<script setup lang="ts">
import { computed } from 'vue'
import { network } from '../core/network'
import { t } from '../core/i18n'

const label = computed(() =>
  network.state === 'online'
    ? t('connection.online')
    : network.state === 'reconnecting'
      ? t('connection.reconnecting')
      : t('connection.offline'),
)
</script>

<template>
  <span
    class="connection-status"
    :data-state="network.state"
    role="status"
    aria-live="polite"
  >
    <span class="status-dot" aria-hidden="true"></span>{{ label }}
  </span>
</template>
